import { render, staticRenderFns } from "./consent.vue?vue&type=template&id=efbfbd3a&scoped=true&"
import script from "./consent.vue?vue&type=script&lang=js&"
export * from "./consent.vue?vue&type=script&lang=js&"
import style0 from "./consent.vue?vue&type=style&index=0&id=efbfbd3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbfbd3a",
  null
  
)

export default component.exports